'use client'

import { cn } from "@heroui/react"

export const Chip = ({ children, className = "", selectValue = false, setSelectValue, disabled, ...props }: any = {}) => {
  return (<div
    {...props}
    aria-checked={selectValue}
    onClick={() => setSelectValue && setSelectValue(!selectValue)}
    data-disabled={disabled}
    className={
      cn("box-border cursor-pointer flex-shrink-0 h-[24px] px-[8px]  border-transparent font-bold text-[12px] text-center leading-[24px] bg-light-gray rounded-full text-theme-primary/70 ",
        "aria-checked:bg-seleced-chip-bg aria-checked:text-theme-primary aria-checked:ring-1 ring-chip-border",
        "data-[disabled=true]:opacity-60 data-[disabled=true]:pointer-events-none",
        className)}>
    {children}
  </div>)
}